import { validationErrorMessageTranslationKeys } from '../../hooks/formValidator/validators';
import { setIsModalOpen, setModalContent } from '../../store/slices/global';
import { MODAL_CONTENT } from '../../app.config.vars/modalContent';
import { store } from '../../store';
import { copyTextToClipboard, generatePassword } from '../../helpers';
import { USER_PASSWORD_MIN_LENGTH } from '../../app.config.vars/stored';
export const validateUpdatedFormFields = ({ updatedFormFields, validateInputField, formState, unit, }) => {
    let updatedFieldsHasErrors = false;
    if (unit === 'institution') {
        if (updatedFormFields.has('name')) {
            const error = validateInputField({
                fieldName: 'name',
                value: formState.name,
            });
            if (error) {
                updatedFieldsHasErrors = true;
            }
        }
    }
    if (unit === 'editor') {
        if (updatedFormFields.has('firstName')) {
            const error = validateInputField({
                fieldName: 'firstName',
                value: formState.firstName,
            });
            if (error) {
                updatedFieldsHasErrors = true;
            }
        }
        if (updatedFormFields.has('lastName')) {
            const error = validateInputField({
                fieldName: 'lastName',
                value: formState.lastName,
            });
            if (error) {
                updatedFieldsHasErrors = true;
            }
        }
    }
    if (updatedFormFields.has('email')) {
        const error = validateInputField({
            fieldName: 'email',
            value: formState.email,
        });
        if (error) {
            updatedFieldsHasErrors = true;
        }
    }
    if (updatedFormFields.has('password')) {
        const error = validateInputField({
            fieldName: 'password',
            value: formState.password,
        });
        if (error) {
            updatedFieldsHasErrors = true;
        }
        else {
            const error = validateInputField({
                fieldName: 'confirmPassword',
                value: formState.confirmPassword,
            });
            if (error) {
                updatedFieldsHasErrors = true;
            }
        }
    }
    if (updatedFormFields.has('confirmPassword')) {
        const error = validateInputField({
            fieldName: 'confirmPassword',
            value: formState.confirmPassword,
        });
        if (error) {
            updatedFieldsHasErrors = true;
        }
    }
    return updatedFieldsHasErrors;
};
export const generateUpdatePayload = ({ formState, updatedFormFields, unit, }) => {
    const individualFields = unit === 'institution'
        ? {
            ...(updatedFormFields.has('name')
                ? { institutionName: formState.name }
                : {}),
        }
        : {
            ...(updatedFormFields.has('firstName')
                ? { firstName: formState.firstName }
                : {}),
            ...(updatedFormFields.has('lastName')
                ? { lastName: formState.lastName }
                : {}),
        };
    return {
        ...individualFields,
        ...(updatedFormFields.has('email') ? { email: formState.email } : {}),
        ...(updatedFormFields.has('isActive') ? { isActive: formState.isActive } : {}),
        ...(updatedFormFields.has('password') && formState.password
            ? { password: formState.password }
            : {}),
    };
};
export const handleSubmitError = ({ error, setSubmitStatus, setFormErrors, setForceFocus, }) => {
    setSubmitStatus('error');
    if (error.response.data.error.code === 'invalid_request') {
        setFormErrors((errors) => ({
            ...errors,
            email: [
                {
                    messageTranslationKey: error.response.data.error.message.trim() ===
                        'email -\u003E User with this email address already exists.'
                        ? validationErrorMessageTranslationKeys.emailAlreadyExist
                        : validationErrorMessageTranslationKeys.invalidEmail,
                },
            ],
        }));
        setForceFocus(true);
    }
    else {
        store.dispatch(setIsModalOpen(true));
        store.dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
    }
};
export const onGeneratePassword = ({ formState, validateInputField, setUpdatedFormFields, }) => {
    const password = generatePassword(USER_PASSWORD_MIN_LENGTH);
    formState.setPassword(password);
    validateInputField({ fieldName: 'password', value: password });
    setUpdatedFormFields((prev) => {
        const newSet = new Set(prev);
        newSet.add('password');
        return newSet;
    });
};
export const onCopyPassword = async ({ formState, setJustCopied, }) => await copyTextToClipboard({ textToCopy: formState.password, setJustCopied });
